<mon-action-menu [monActionMenuItems]="options">
    <span translate>Action</span>
</mon-action-menu>